import React, { useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AppSettings } from './../../config/app-settings.js';
import { Card } from './../../components/card/card.jsx';
import { useChat } from '../../hooks/useChat';
import ChatSidebar from '../../components/chat/ChatSidebar';
import ChatContent from '../../components/chat/ChatContent';
import useAuth from '../../hooks/useAuth.js';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AiChat() {
	const { user } = useAuth();
	const currentUserId = user?.id;
	const {
		messages,
		inputValue,
		conversationId,
		conversations,
		isStreaming,
		streamingEnabled,
		aiProvider,
		handleInputChange,
		handleKeyPress,
		handleSendMessage,
		loadConversation,
		deleteConversation,
		createNewConversation,
		updateConversationTitle,
		setStreamingEnabled,
		setAiProvider
	} = useChat(API_BASE_URL, currentUserId);

	// Add CSS styles for markdown content
	useEffect(() => {
		const style = document.createElement('style');
		style.textContent = `
			.markdown-content h1, .markdown-content h2, .markdown-content h3, .markdown-content h4 {
				margin-top: 1rem;
				margin-bottom: 0.5rem;
				font-weight: bold;
			}
			.markdown-content h1 { font-size: 1.5rem; }
			.markdown-content h2 { font-size: 1.3rem; }
			.markdown-content h3 { font-size: 1.1rem; }
			.markdown-content h4 { font-size: 1rem; }
			.markdown-content ul, .markdown-content ol {
				margin: 0.5rem 0;
				padding-left: 1.5rem;
			}
			.markdown-content li {
				margin-bottom: 0.25rem;
			}
			.markdown-content p {
				margin-bottom: 0.5rem;
			}
			.markdown-content code {
				background-color: rgba(0,0,0,0.1);
				padding: 0.2rem 0.4rem;
				border-radius: 0.25rem;
				font-family: 'Courier New', monospace;
				font-size: 0.9em;
			}
			.markdown-content a {
				color: #007bff;
				text-decoration: underline;
			}
			.markdown-content a:hover {
				color: #0056b3;
			}
			.hljs-container {
				overflow-x: auto;
				font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
				font-size: 0.875rem;
				line-height: 1.5;				
			}
			.hljs-container pre {
				margin: 0;
				padding: 0;
				background: transparent !important;
			}
			.hljs-container code {
				background: transparent !important;
				padding: 0 !important;
				border-radius: 0 !important;
				color: rgba(185, 185, 185, 0.8) !important;
			}
			.typing-animation {
				animation: typing 0.5s ease-in-out;
			}
			@keyframes typing {
				from { opacity: 0; transform: translateY(10px); }
				to { opacity: 1; transform: translateY(0); }
			}
			.ai-spinner {
				animation: pulse 1.5s ease-in-out infinite;
			}
			@keyframes pulse {
				0%, 100% { opacity: 0.5; }
				50% { opacity: 1; }
			}
		`;
		document.head.appendChild(style);

		return () => {
			document.head.removeChild(style);
		};
	}, []);

	return (
		<AppSettings.Consumer>
			{({ appSidebarMinified, appSidebarHide }) => (
			  <Card className="" style={{ zIndex: '1', height: '78vh' }}>
				<div className="d-flex h-100">
					{/* Chat Sidebar */}
					<div className="w-300px border-end border-gray-500 border-opacity-25">
						<PerfectScrollbar className="h-100">
							<ChatSidebar
							conversations={conversations}
							streamingEnabled={streamingEnabled}
							setStreamingEnabled={setStreamingEnabled}
							isStreaming={isStreaming}
							aiProvider={aiProvider}
							setAiProvider={setAiProvider}
							onNewChat={createNewConversation}
							onLoadConversation={loadConversation}
							onUpdateConversationTitle={updateConversationTitle}
							onDeleteConversation={deleteConversation}
						/>
						</PerfectScrollbar>
					</div>

					{/* Chat Content */}
					<div className="flex-1">
						<ChatContent
							messages={messages}
							inputValue={inputValue}
							onInputChange={handleInputChange}
							onSendMessage={handleSendMessage}
							onKeyPress={handleKeyPress}
							conversationId={conversationId}
							isStreaming={isStreaming}
						/>
					</div>
				</div>
			  </Card>		
			)}
		</AppSettings.Consumer>
	);
}

export default AiChat;